import { snakeCaseStatuses } from '../../../types/annotationStatus';
import { hiddenStatuses } from './statuses';

export const visibleStatuses = snakeCaseStatuses.filter(
  status => !hiddenStatuses.some(excludedStatus => excludedStatus === status)
);
